import { AnnotationProps } from "../components/Annotation";

const MARGIN = 10;

const getCoordPercentage = (e: React.MouseEvent<HTMLElement>) => ({
    x: (e.nativeEvent.offsetX / e.currentTarget.offsetWidth) * 100,
    y: (e.nativeEvent.offsetY / e.currentTarget.offsetHeight) * 100,
});

const marginToPercentage = (container: HTMLImageElement) => ({
    marginX: (MARGIN / container.width) * 100,
    marginY: (MARGIN / container.height) * 100,
});

export const TYPE = "POINT";

export const showEditor = false;

export const showEditorInline = false;

export function intersects({ x, y }: any, geometry: any, container: HTMLImageElement) {
    const { marginX, marginY } = marginToPercentage(container);

    if (x < geometry.x - marginX) {
        return false;
    }
    if (y < geometry.y - marginY) {
        return false;
    }
    if (x > geometry.x + marginX) {
        return false;
    }
    if (y > geometry.y + marginY) {
        return false;
    }

    return true;
}

export function area(container: HTMLImageElement) {
    const { marginX, marginY } = marginToPercentage(container);

    return marginX * marginY;
}

export const methods = {
    onClick(annotation: AnnotationProps, e: React.MouseEvent<HTMLElement>) {
        return {
            ...annotation,
            selection: {
                ...annotation.selection,
                showEditor: true,
                mode: "EDITING",
            },
            geometry: {
                ...annotation.geometry,
                ...getCoordPercentage(e),
                width: 0,
                height: 0,
                type: TYPE,
            },
        };
    },
};

export default {
    TYPE,
    intersects,
    area,
    methods,
    showEditor,
    showEditorInline,
};
